import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@kcftech/design-system';
import { Spinner } from 'components/spinner/Spinner';
import { useUserDateTimeFormat } from 'custom_hooks/useUserDateTimeFormat';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const ButtonContent = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`;

export type LastUpdatedProps = Readonly<{
    isLoading: boolean;
    reload: () => void;
    /** disables reloading without showing it as loading */
    disabled?: boolean;
}>;

export function LastUpdated({ isLoading, reload, disabled }: LastUpdatedProps) {
    const { formatTime } = useUserDateTimeFormat();
    const [lastUpdated, setLastUpdated] = useState(new Date());
    const wasLoadingRef = useRef(isLoading);

    useEffect(() => {
        // Update timestamp when loading changes from true to false
        if (wasLoadingRef.current && !isLoading) {
            setLastUpdated(new Date());
        }
        wasLoadingRef.current = isLoading;
    }, [isLoading]);

    const onReload = () => {
        reload();
        setLastUpdated(new Date());
    };

    return (
        <StyledButton
            appearance="subtle"
            spacing="compact"
            onClick={onReload}
            disabled={isLoading || disabled}
        >
            <ButtonContent>
                Updated {formatTime(lastUpdated)}
                {isLoading ? (
                    <Spinner size="1x" />
                ) : (
                    <FontAwesomeIcon icon={faArrowsRotate} />
                )}
            </ButtonContent>
        </StyledButton>
    );
}
